var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.loading)?_c('loading-spinner'):_c('div',[_c('back-button',{attrs:{"fixed":""}}),_c('routine-detail',{attrs:{"routine":_vm.currentRoutine},on:{"selectRoutine":_vm.onSelectRoutine}}),_c('assign-routine-dialog',{ref:"assign",attrs:{"routine-id":_vm.routineId,"coach-id":_vm.coachId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }